const { UPDATE_SEGMENTS } = require('constants/actionTypes/user');

const updateSegments = data => ({
    type: UPDATE_SEGMENTS,
    payload: data
});

module.exports = {
    updateSegments
};
